import { HLS_TRACK_TYPES } from 'src/consumer/constants'

export const TrackResponse = {
  type: HLS_TRACK_TYPES[1].id,
  duration: 0,
  slides: [],
  slide: null,
  subtitleFileId: '',
}
